/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ModalGeneric } from 'ypf-pas-general-ui-components';
import { Col, Row } from 'react-bootstrap';

import { getReferenceColors } from '../../services/yclickServices';
import { colorReferenceApprover, colorReferenceInspector } from '../../utils/dataEnum';

import FakeDayCell from './components/FakeDayCell/FakeDayCell';
import ReferenceSquare from './components/ReferenceSquare/ReferenceSquare';

import './StatusReferenceModal.scss';

const StatusReferenceModal = ({ show, onHide }) => {
  const [colorsApprover, setColorsApprover] = useState([]);
  const [colorsInspector, setColorsInspector] = useState([]);

  const getColors = async () => {
    const res = await getReferenceColors();

    const listaAprobador = await res?.listaEstadosColoresAprobador.map((estado) => {
      const [textColor, bgColor] = estado.color.split(',');

      return { ...estado, textColor, bgColor };
    });

    setColorsApprover(listaAprobador);
    setColorsInspector(res.listaEstadosColoresInspeccion);
  };

  useEffect(() => {
    getColors();
  }, []);

  return (
    <ModalGeneric
      backdrop
      infoModal
      onHide={onHide}
      primaryAction={onHide}
      primaryActionLabel="Salir"
      primaryActionVariant="outline-primary"
      show={show}
      size="xl"
      title="Referencia de estados"
    >
      <>
        <Row className="mb-4">
          <h6 className="mb-3 mt-2 title-sections">Ejemplo</h6>
          <Col sm={2}>
            <FakeDayCell colorsApprover={colorsApprover} colorsInspector={colorsInspector} />
          </Col>

          <Col sm={2}>
            <div className="d-flex" style={{ height: '50px' }}>
              <div
                className="vr"
                style={{
                  color: colorsApprover?.length
                    ? colorsApprover.find((obj) => obj.id === colorReferenceApprover.aprobada)
                        .bgColor
                    : '#219E66',
                  width: '2px'
                }}
              />
              <h6
                className="mx-3"
                style={{
                  color: colorsApprover.length
                    ? colorsApprover.find((obj) => obj.id === colorReferenceApprover.aprobada)
                        .bgColor
                    : '#219E66'
                }}
              >
                Área superior
              </h6>
            </div>
            <div className="d-flex " style={{ height: '20px' }}>
              <div
                className="vr"
                style={{
                  color: colorsInspector.length
                    ? colorsInspector.find(
                        (obj) => obj.id === colorReferenceInspector.actuarInspector
                      ).color
                    : '#616161',
                  width: '2px'
                }}
              />
              <h6
                className="mx-3"
                style={{
                  color: colorsInspector.length
                    ? colorsInspector.find(
                        (obj) => obj.id === colorReferenceInspector.actuarInspector
                      ).color
                    : '#616161'
                }}
              >
                Área inferior
              </h6>
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col sm={4}>
            <h6 className="mb-2 mt-2 title-sections">Área Superior - Aprobador</h6>
            {colorsApprover?.map((status) => (
              <ReferenceSquare
                approver
                key={`${status.id}-${status.descripcion}`}
                status={status}
              />
            ))}
          </Col>
          <Col>
            <h6 className="mb-2 mt-2 title-sections">Área Inferior - Inspección</h6>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                flexWrap: 'wrap',
                height: '290px',
                width: '600px'
              }}
            >
              {colorsInspector?.map((status) => (
                <ReferenceSquare
                  approver={false}
                  key={`${status.id}-${status.descripcion}`}
                  status={status}
                />
              ))}
            </div>
          </Col>
        </Row>
        <hr />
      </>
    </ModalGeneric>
  );
};

export default StatusReferenceModal;

StatusReferenceModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func
};

StatusReferenceModal.defaultProps = {
  show: false,
  onHide: () => {
    /* Empty */
  }
};
